import { render, staticRenderFns } from "./ColorAdd.vue?vue&type=template&id=77f6499f&"
import script from "./ColorAdd.vue?vue&type=script&lang=js&"
export * from "./ColorAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports